export default "__VITE_ASSET__c6367bb5__"